<template>
  <div class="main">
    <div class="container">
      <div class="card card-muni" :class="{ loginuser: $root.$userLogged }">
        <div class="row">
          <div
            class="col-6 col-md-3"
            v-for="(item, index) in lisItems"
            :key="index"
          >
            <div class="item">
              <!-- <router-link :to="validaOpc(item.login, item.link)"> -->
              <a @click.prevent="validaOpc(item.login, item.link)">
                <div class="content-img">
                  <img :src="require(`../../assets/${item.icon}.png`)" />
                </div>
                <h5>
                  <b> {{ item.title }}</b>
                </h5>
                <template v-if="item.conIconDes == 0"
                  ><p>{{ item.description }}</p></template
                >
                <template v-else
                  ><img :src="require(`../../assets/${item.description}.png`)"
                /></template>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="card card-muni" :class="{ loginuser: $root.$userLogged }">
        <div class="row">
          <div  class="col-md-3" >
             <h3>Pago Directo</h3>
          </div>
        </div>
        <div class="row">
          <!-- <div  class="col-md-1" ></div> -->
          <div class="col-md-6" style="margin-left:30px !important">
            <ol>
                  <li
                    v-for="requisito of lisItemsPagoDirecto"
                    :key="requisito.idRequisitoTramite"
                  >
                    <a href="javascript:;" @click="verTramitePagoDirecto(requisito)"  style="text-decoration: underline;">
                     {{ requisito.nombreRequisitoTramite }} 
                    </a> 
                  </li>
                </ol>
                <br>
          </div>
        </div>
      </div>


    </div>
    <b-modal
      id="modalCasillaElectronica"
      hide-footer
      title=""
      @hidden="clearData"
    >
      <div class="form-group" style="margin-bottom: 0.5rem; !important">
        <div class="row mt-2">
          <div class="col-md-12 pr-0">
            <div class="mt-12" style="text-align: center; color: #0078cf">
              <h5><b> AUTORIZACIÓN DE USO DE CASILLA ELECTRÓNICA </b></h5>
            </div>
            <div>
              <div class="row">
                <div class="col-md-12" style="text-align: center">
                  <div class="custom-control custom-checkbox my-1 mr-sm-2">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="customControlInline"
                      v-model="flagCasillaElectronica"
                    />
                    <label
                      class="custom-control-label"
                      for="customControlInline"
                      ><b>He leído y acepto términos y condiciones</b></label
                    >
                  </div>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-md-12"
                  style="text-align: center; color: #0078cf"
                >
                  <a href="javascript:;" @click="openModalCasillaElectronica">
                    <u> Ver términos y condiciones </u></a
                  >
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-md-12" style="text-align: center">
                  <button
                    class="btn btn-default"
                    @click="ActualizaFlagCasillaElectronica"
                  >
                    Confirmar
                  </button>
                  <button class="btn btn-primary" @click="omitir">
                    Omitir
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="visorModal"
      hide-footer
      title="Términos y Condiciones"
      size="huge"
    >
      <div class="contenedor-documento">
        <div class="row">
          <div style="width: 95%">
            <iframe
              :src="rutaTerminosCasilla"
              style="width: 100%; height: 900px"
              type="application/pdf"
              frameborder="0"
            ></iframe>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<style lang="scss">
.modal .modal-huge {
  max-width: 900px;
  width: 900px;
  max-height: 500px;
  height: 500px;
}
.modal-backdrop {
  background: #002646a8;
}
.modal-content {
  border: 0px;
  border-radius: 20px;
  border: solid 1px #e0e0e0;
  // box-shadow: 0px 0px 12px 3px rgba(0, 125, 197, 0.19);
}
.modal-body,
.modal-header {
  box-shadow: none;
}
</style>
<style>
.header-nav {
  background: #e9ecef;
  padding: 15px 0px;
  color: #0066cc;
}
.subtitulo {
  min-height: 57px;
  position: relative;
  display: flex;
  align-items: center;
}
.col-md-12 {
  padding-right: 15px !important;
}
</style>
<script>
import Login from "./Login.vue";
import Util from "../../tools/util";
import "regenerator-runtime/runtime";
import axios from "axios";
import Constantes from "../../store/constantes.js";
export default {
  components: { Login },
  data() {
    return {
      flagCasillaElectronica: true,
      rutaTerminosCasilla: Constantes.filesRecupera + "/14/1/0",
      estiloMuestraLogin: "",
      estiloMuestraUsuario: "none",
      mostrarDivPreLogin: true,
      nombreUsuario: "",
      lisItemsPagoDirecto:[],
      lisItems: [
        {
          title: "Trámites Virtuales",
          description: "Registra tus trámites de manera virtual.",
          link: "/plataformatramiteVirtual",
          icon: "mesadepartes",
          conIconDes: 0,
          login: 1,
        },
        /* {
                    title : 'Consulte su Trámite',
                    description: 'Consulta el estado de tus trámites ingresados.',
                    link: '/consultaTramite',
                    icon: 'consultatutramite',
                    login: 1
                }
                , */
        {
          title: "Pago en Línea",
          description: "Realiza el pago de tu estado de cuenta.",
          link: "/pago-tributo",
          icon: "pagoenlinea",
          conIconDes: 0,
          login: 1,
        },
        {
          title: "Estado de Cuenta",
          description: "Consulta tu estado de cuenta.",
          link: "/estado-cuenta",
          icon: "estadodecuenta",
          conIconDes: 0,
          login: 1,
        },
        {
          title: "Cartilla Tributaria por año",
          description: "ICONO-HR-PU-2",
          link: "/contribuyente-cuponera",
          icon: "cartilla2",
          conIconDes: 1,
          login: 1,
        },
        {
          title: "Alquiler de cancha de tenis y pickelball",
          description: "Consulta y reserva tu cancha.",
          link: "/AlquilerTenis",
          icon: "tenis",
          conIconDes: 0,
          login: 1,
        },
        // {
        //     title : 'Solicitud de Atención Vecinal',
        //     description: 'Registralo de manera virtual.',
        //     link: '/registro-save',
        //     icon: 'icono_save',
        //     conIconDes: 0,
        //     login: 1
        // }
      ],
    };
  },
  created() {
    if (localStorage.getItem("validarEntradaToken") == 1) {
      localStorage.removeItem("validarEntradaToken");
      window.location.reload();
    }
    window.rutaReturn = "/";
    this.obtenerPagoDirecto();
    this.validaCasillaElectronica();
  },
  mounted() {
    let appRentas = Util.storage.get("appRentas");
    if (appRentas != null && appRentas.cuenta != null) {
      delete appRentas.cuenta;
      Util.storage.set("appRentas", appRentas);
    }

    this.ValidaLogueo();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "pagina_vista",
      "page-url": "/plataforma",
      "page-title": "plataforma",
    });
  },
  methods: {
    async ValidaLogueo() {
      let flagLogueado = await localStorage.getItem("logueadoTramite");
      if (flagLogueado === "true") {
        this.mostrarDivPreLogin = false;
        this.estiloMuestraLogin = "none";
        this.estiloMuestraUsuario = "";
        this.nombreUsuario = localStorage.getItem(
          "nombreCompletoLogueadoTramite"
        );
      } else {
        this.mostrarDivPreLogin = true;
        this.estiloMuestraLogin = "";
        this.estiloMuestraUsuario = "none";
        this.nombreUsuario = localStorage.getItem(
          "nombreCompletoLogueadoTramite"
        );
      }
    },
    validaOpc(opc, link) {
      if (opc == 2 && this.$root.$userLogged == false) {
        this.$root.$userCuponera = false;
        this.$router.push(link);
      } else {
        this.$root.$userCuponera = true;
        this.$router.push(link);
      }
    },
    validaCasillaElectronica() {
      var valid = localStorage.getItem("idVerificador");
      if (valid == 1 && (Util.storage.get("persona")===undefined || Util.storage.get("persona")===null) ) {
        axios
          .get(
            Constantes.rutaTramite +
              //"detalleUsuarioPlataforma/", {headers: {"validaCasilla":true}
              "detalleUsuarioPlataforma/", {headers: {'idUsr': localStorage.getItem('idUsuarioLogueadoTramite').toString(), 'validaCasilla': true }
            })
          .then((response) => {
            let data = response.data.data;
            Util.storage.set("tipoDocumentoLogueado", data[0].persona.tipoDocumento);
            let casillaEletronica = data[0].flagCasillaElectronica;
            if (casillaEletronica != 1) {
              //this.$bvModal.show("modalCasillaElectronica");
            }
          })
          .catch((e) => console.log(e));
      }
    },
    openModalCasillaElectronica() {
      this.$bvModal.show("visorModal");
    },
    ActualizaFlagCasillaElectronica() {
      if (this.flagCasillaElectronica) {
        let usuario = {};
        usuario.idUsuarioPlataforma = localStorage.getItem(
          "idUsuarioLogueadoTramite"
        );
        axios
          .post(Constantes.rutaTramite + "activaCasillaElectronica/", usuario)
          .then((response) => {
            if (response.data.success) {
              //this.$bvModal.hide("modalCasillaElectronica");
              this.$swal.fire({
                icon: "success",
                title: "Se acepto terminos y condiciones",
                showConfirmButton: false,
                timer: 1900,
              });
            } else {
              this.$swal({
                icon: "info",
                title: "Aviso",
                text: "Sucedió un error al actualizar",
              });
            }
          })
          .catch((e) => console.log(e));
      } else {
        this.omitir();
      }
    },
    omitir() {
      localStorage.setItem("idVerificador", 0);
      this.$bvModal.hide("modalCasillaElectronica");
    },
    clearData() {
      localStorage.setItem("idVerificador", 0);
    },
    obtenerPagoDirecto(){
        axios.post(Constantes.rutaTramite + "obtenerPagoDirecto/", []).then((response) => {
            if (response.data.data) {
              this.lisItemsPagoDirecto=response.data.data;
            }
          })
          .catch((e) => console.log(e));
    },
    verTramitePagoDirecto(row) {
      //let endpoint = "/descripcion/" + +row.id_area+"&"+row.idRequisitoTramite+"&0&2&1";
      let endpoint = "/pagodirecto/ce/"+row.id_area+"&"+row.idRequisitoTramite+"&0&2&1";
      this.$router.push(endpoint); 
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Inicio/Plataforma.vue